import Select from "react-select";

export default function DBLeadModal({
  productTypeDisable,
  onSubCategoryChange,
  subCategoryDisable,
  getSubCategoryLoading,
  getProductTypeLoading,
  onCategoryChange,
  handleSelectChange,
  lookupUsers,
  lookupCategory,
  lookupSubCategory,
  lookupTypeProduct,
  auth,
  modalRef,
  form,
  editId,
  onChange,
  onSubmit,
  submitLoading,
  onCancelEdit,
  validated,
  errors,
}) {
  const mos = lookupUsers.mos?.map((mo) => ({
    value: mo.id,
    label: mo.name,
  }));
  const tls = lookupUsers.tls?.map((tls) => ({
    value: tls.id,
    label: tls.name,
  }));
  const sales = lookupUsers.sales?.map((sales) => ({
    value: sales.id,
    label: sales.name,
  }));

  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={onSubmit}
    >
      <div
        className="modal fade"
        id="vendorModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalLabel"
        ref={modalRef}
      >
        <div className="modal-dialog modal-lg modal-vendor">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalLabel">
                {editId ? "Edit Leads" : "Tambah Leads"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body bg-light">
              <div className="d-flex flex-column gap-4">
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-header bg-white fw-semibold">
                    <i className="fa fa-users me-2 text-primary"></i> Tim
                    Penanggung Jawab
                  </div>
                  <div className="card-body row g-3">
                    <div className="col-md-6 mb-3">
                      <label className="form-label" htmlFor="mo_id">
                        MO
                      </label>
                      <Select
                        inputId="mo_id"
                        isMulti
                        name="mo_id"
                        options={mos || []}
                        className={`basic-multi-select ${
                          errors.mo_id ? "is-invalid" : ""
                        }`}
                        classNamePrefix="select"
                        value={(mos || []).filter((m) =>
                          form.mo_id?.includes(m.value)
                        )}
                        onChange={handleSelectChange("mo_id")}
                      />
                      {errors.mo_id && (
                        <div className="invalid-feedback d-block">
                          {errors.mo_id || "MO wajib diisi."}
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label" htmlFor="tls_id">
                        TLS
                      </label>
                      <div className="form-floating">
                        <Select
                          isMulti
                          name="tls_id"
                          options={tls || []}
                          className={`basic-multi-select ${
                            errors.tls_id ? "is-invalid" : ""
                          }`}
                          classNamePrefix="select"
                          value={(tls || []).filter((m) =>
                            form.tls_id.includes(m.value)
                          )}
                          onChange={handleSelectChange("tls_id")}
                        />
                        {errors.tls_id && (
                          <div className="invalid-feedback d-block">
                            {errors.tls_id || "TLS wajib diisi."}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label" htmlFor="sales_id">
                        Sales
                      </label>
                      <div className="form-floating">
                        <Select
                          isMulti
                          name="sales_id"
                          options={sales || []}
                          className={`basic-multi-select ${
                            errors.sales_id ? "is-invalid" : ""
                          }`}
                          classNamePrefix="select"
                          value={(sales || []).filter((m) =>
                            form.sales_id.includes(m.value)
                          )}
                          onChange={handleSelectChange("sales_id")}
                        />
                        {errors.sales_id && (
                          <div className="invalid-feedback d-block">
                            {errors.sales_id || "Sales wajib diisi."}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-header bg-white fw-semibold">
                    <i className="fa fa-id-card me-2 text-info"></i> Detail
                    Kontak
                  </div>
                  <div className="card-body row g-3">
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.name ? "is-invalid" : ""
                          }`}
                          id="name"
                          name="name"
                          value={form.name || ""}
                          onChange={onChange}
                          placeholder="Cabang"
                          required
                        />
                        <label htmlFor="name">Nama</label>
                        {errors.name && (
                          <div className="invalid-feedback">
                            {errors.name || "Nama wajib diisi."}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="email"
                          name="email"
                          value={form.email || ""}
                          onChange={onChange}
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          placeholder="Email"
                        />
                        <label htmlFor="email">Email</label>
                        <div className="invalid-feedback">{errors.email}</div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">No HP / Telp</label>
                      <div className="input-group">
                        <span className="input-group-text">+62</span>
                        <input
                          type="text"
                          name="phone_number"
                          value={form.phone_number || ""}
                          onChange={onChange}
                          className={`form-control ${
                            errors.phone_number ? "is-invalid" : ""
                          }`}
                          placeholder="8123456789"
                          required
                        />
                        <div className="invalid-feedback">
                          {errors.phone_number || "No HP / Telp wajib diisi."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-header bg-white fw-semibold">
                    <i className="fa fa-box-open me-2 text-warning"></i> Detail
                    Barang
                  </div>
                  <div className="card-body row g-3">
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="organization"
                          name="organization"
                          value={form.organization || ""}
                          onChange={onChange}
                          className={`form-control ${
                            errors.organization ? "is-invalid" : ""
                          }`}
                          placeholder="Instansi/Business"
                          required
                        />
                        <label htmlFor="organization">Instansi/Business</label>
                        <div className="invalid-feedback">
                          {errors.organization ||
                            "Instansi/Business wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.product_needs ? "is-invalid" : ""
                          }`}
                          id="product_needs"
                          name="product_needs"
                          value={form.product_needs || ""}
                          onChange={onChange}
                          placeholder="Kebutuhan Product"
                          required
                        />
                        <label htmlFor="product_needs">Kebutuhan Product</label>
                        {errors.product_needs && (
                          <div className="invalid-feedback">
                            {errors.product_needs ||
                              "Kebutuhan Product wajib diisi."}
                          </div>
                        )}
                      </div>
                    </div>
                    <hr />
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="product_category"
                          value={form.product_category || ""}
                          onChange={onCategoryChange}
                          className={`form-select ${
                            errors.product_category ? "is-invalid" : ""
                          }`}
                          required
                        >
                          <option value="">-- Pilih Kategori --</option>
                          {lookupCategory.map((mo) => (
                            <optgroup key={mo.id} label={`Pak ${mo.name}`}>
                              {mo.categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                  {cat.name}
                                </option>
                              ))}
                            </optgroup>
                          ))}
                        </select>
                        <label htmlFor="">Kategory Product</label>
                        <div className="invalid-feedback">
                          {errors.product_category ||
                            "Kategory Product wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating position-relative">
                        <select
                          name="product_subcategory"
                          value={form.product_subcategory || ""}
                          onChange={onSubCategoryChange}
                          className={`form-select ${
                            errors.product_subcategory ? "is-invalid" : ""
                          }`}
                          disabled={subCategoryDisable}
                          required
                        >
                          <option value="">-- Pilih Sub Kategori --</option>
                          {lookupSubCategory &&
                            lookupSubCategory.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.name}
                              </option>
                            ))}
                        </select>
                        <label>Sub Kategory Product</label>

                        {getSubCategoryLoading && (
                          <div
                            className="position-absolute top-50 end-50 translate-middle-y me-3"
                            style={{ pointerEvents: "none" }}
                          >
                            <div
                              className="spinner-border spinner-border-sm text-secondary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        )}

                        <div className="invalid-feedback">
                          {errors.product_subcategory ||
                            "Sub Kategory Product wajib diisi."}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="product_type"
                          value={form.product_type || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.product_type ? "is-invalid" : ""
                          }`}
                          disabled={productTypeDisable}
                          required
                        >
                          <option value="">-- Pilih Jenis Produk --</option>
                          {lookupTypeProduct &&
                            lookupTypeProduct.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.name}
                              </option>
                            ))}
                        </select>
                        <label htmlFor="">Jenis Produk</label>

                        {getProductTypeLoading && (
                          <div
                            className="position-absolute top-50 end-50 translate-middle-y me-3"
                            style={{ pointerEvents: "none" }}
                          >
                            <div
                              className="spinner-border spinner-border-sm text-secondary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </div>
                        )}

                        <div className="invalid-feedback">
                          {errors.product_category ||
                            "Tipe Product wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <hr />
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="organization_type"
                          value={form.organization_type || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.organization_type ? "is-invalid" : ""
                          }`}
                          required
                        >
                          <option value="">
                            -- Pilih Pemerintah/Swasta --
                          </option>
                          <option value="Pemerintah">Pemerintah</option>
                          <option value="Swasta">Swasta</option>
                        </select>
                        <label htmlFor="organization_type">
                          Pemerintah/Swasta
                        </label>
                        <div className="invalid-feedback">
                          {errors.organization_type ||
                            "Pemerintah/Swasta wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="lead_source"
                          value={form.lead_source || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.lead_source ? "is-invalid" : ""
                          }`}
                          required
                        >
                          <option value="">-- Pilih Sumber --</option>
                          <option value="Google Ads">Google Ads</option>
                          <option value="SEO">SEO</option>
                          <option value="Meta Ads">Meta Ads</option>
                          <option value="Woowa Marketing">
                            Woowa Marketing
                          </option>
                          <option value="Email">Email</option>
                          <option value="Social Media">Social Media</option>
                          <option value="Chat Inaproc">Chat Inaproc</option>
                          <option value="Telephone Kantor">
                            Telephone Kantor
                          </option>
                          <option value="WA, Telp By Direktur">
                            WA, Telp By Direktur
                          </option>
                          <option value="Broker/Relasi">Broker/Relasi</option>
                          <option value="Repeat Order">Repeat Order</option>
                          <option value="Inaproc/E-katalog">
                            Inaproc/E-katalog
                          </option>
                          <option value="Website">Website</option>
                          <option value="Minkom">Minkom</option>
                        </select>
                        <label htmlFor="lead_source">Sumber Leads</label>
                        <div className="invalid-feedback">
                          {errors.lead_source || "Sumber Leads wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="company"
                          value={form.company || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.company ? "is-invalid" : ""
                          }`}
                          required
                        >
                          <option value="">-- Pilih Perusahaan --</option>
                          <option value="SK">SK</option>
                          <option value="BCS">BCS</option>
                          <option value="MBA">MBA</option>
                          <option value="DHA">DHA</option>
                          <option value="ITG">ITG</option>
                          <option value="KNP">KNP</option>
                          <option value="KPK">KPK</option>
                          <option value="TSI">TSI</option>
                          <option value="SAR">SAR</option>
                          <option value="SK. Suroboyo Mandiri">
                            SK. Suroboyo Mandiri
                          </option>
                          <option value="SKTP">SKTP</option>
                          <option value="SKAP">SKAP</option>
                          <option value="SKSM">SKSM</option>
                          <option value="SKMJ">SKMJ</option>
                          <option value="SKCI">SKCI</option>
                        </select>
                        <label htmlFor="company">Perusahaan</label>
                        <div className="invalid-feedback">
                          {errors.company || "Perusahaan wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="lead_status"
                          value={form.lead_status || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.lead_status ? "is-invalid" : ""
                          }`}
                          required
                        >
                          {" "}
                          <option value="">-- Pilih Status --</option>
                          <option value="Cold" className="text-primary fw-bold">
                            Cold
                          </option>
                          <option value="Warm" className="text-warning fw-bold">
                            Warm
                          </option>
                          <option value="Hot" className="text-danger fw-bold">
                            Hot
                          </option>
                        </select>
                        <label htmlFor="lead_status">Status Leads</label>
                        <div className="invalid-feedback">
                          {errors.lead_status || "Status Leads wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="spk_status"
                          value={form.spk_status || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.spk_status ? "is-invalid" : ""
                          }`}
                          required
                        >
                          {" "}
                          <option value="">-- Pilih Proses --</option>
                          <option value="SPK">SPK</option>
                          <option value="On Progress">On Progress</option>
                          <option value="Tidak SPK">Tidak SPK</option>
                        </select>
                        <label htmlFor="spk_status">Proses</label>
                        <div className="invalid-feedback">
                          {errors.spk_status || "Proses wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="date"
                          name="click_plan"
                          value={form.click_plan || ""}
                          onChange={onChange}
                          className={`form-control ${
                            errors.click_plan ? "is-invalid" : ""
                          }`}
                          placeholder="Rencana Klik"
                          required
                        />
                        <label htmlFor="click_plan">Rencana Klik</label>
                        <div className="invalid-feedback">
                          {errors.click_plan || "Rencana Klik wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <select
                          name="response_status"
                          value={form.response_status || ""}
                          onChange={onChange}
                          className={`form-select ${
                            errors.response_status ? "is-invalid" : ""
                          }`}
                          required
                        >
                          <option value="">-- Pilih Status --</option>
                          <option value="Respon">Respon</option>
                          <option value="Tidak Respon">Tidak Respon</option>
                        </select>
                        <label htmlFor="response_status">Status Respon</label>
                        <div className="invalid-feedback">
                          {errors.response_status ||
                            "Status respon wajib dipilih."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card shadow-sm border-0 rounded-4">
                  <div className="card-header bg-white fw-semibold">
                    <i className="fa fa-coins me-2 text-success"></i> Nominal
                  </div>
                  <div className="card-body row g-3">
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          name="budget"
                          value={
                            form.budget
                              ? new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  minimumFractionDigits: 0,
                                }).format(form.budget)
                              : ""
                          }
                          onChange={onChange}
                          className={`form-control ${
                            errors.budget ? "is-invalid" : ""
                          }`}
                          placeholder="Pagu"
                        />
                        <label htmlFor="budget">Pagu</label>
                        <div className="invalid-feedback">
                          {errors.budget || "Pagu wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          name="estimated_budget"
                          value={
                            form.estimated_budget
                              ? new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  minimumFractionDigits: 0,
                                }).format(form.estimated_budget)
                              : ""
                          }
                          onChange={onChange}
                          className={`form-control ${
                            errors.estimated_budget ? "is-invalid" : ""
                          }`}
                          placeholder="RAB"
                        />
                        <label htmlFor="estimated_budget">RAB</label>
                        <div className="invalid-feedback">
                          {errors.estimated_budget || "RAB wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          name="contract_value"
                          value={
                            form.contract_value
                              ? new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  minimumFractionDigits: 0,
                                }).format(form.contract_value)
                              : ""
                          }
                          onChange={onChange}
                          className={`form-control ${
                            errors.contract_value ? "is-invalid" : ""
                          }`}
                          placeholder="Nominal SPK"
                        />
                        <label htmlFor="contract_value">Nominal SPK</label>
                        <div className="invalid-feedback">
                          {errors.contract_value || "Nominal SPK wajib diisi."}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <input
                          type="text"
                          name="profit"
                          value={`${form.profit || 0} %`}
                          className="form-control"
                          readOnly
                          disabled
                        />
                        <label htmlFor="contract_value">Profit</label>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-floating">
                        <textarea
                          type="text"
                          name="notes"
                          value={form.notes || ""}
                          onChange={onChange}
                          className={`form-control ${
                            errors.notes ? "is-invalid" : ""
                          }`}
                          style={{ height: "150px" }}
                          placeholder="Keterangan"
                          required
                        />
                        <label htmlFor="notes">Keterangan</label>
                        <div className="invalid-feedback">
                          {errors.notes || "Keterangan wajib diisi."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {editId && (
                <button
                  type="button"
                  className="btn btn-secondary me-auto"
                  onClick={onCancelEdit}
                >
                  Batal Edit
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitLoading}
              >
                {submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
